export default "__VITE_ASSET__COPKo6Cw__"